import { useState } from 'react';

export const useModalsState = () => {
    const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
    const [isDealSentOpen, setIsDealSentOpen] = useState(false);
    const [isThankYouOpen, setIsThankYouOpen] = useState(false);

    return {
        isCustomerModalOpen,
        setIsCustomerModalOpen,
        isDealSentOpen,
        setIsDealSentOpen,
        isThankYouOpen,
        setIsThankYouOpen,
    };
};
